export default __webpack_public_path__ + "259c15cbbe2cd2d15c3000891db42c5c.png";